var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVision(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "800px",
    width: "800px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 379.57 379.57",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M320.962,123.055c-30.868-24.218-78.682-53.087-131.177-53.087c-52.263,0-100.19,29.226-131.192,53.744 C27.928,147.963,0,179.456,0,189.785c0,11.773,26.846,42.62,58.623,67.36c25.163,19.591,75.664,52.457,131.162,52.457 c55.526,0,106.01-32.82,131.161-52.384c31.778-24.719,58.625-55.599,58.625-67.433C379.57,178.732,352.183,147.55,320.962,123.055z  M189.785,268.254c-43.337,0-78.468-35.132-78.468-78.468c0-43.337,35.131-78.468,78.468-78.468s78.468,35.131,78.468,78.468 C268.253,233.122,233.122,268.254,189.785,268.254z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVision);
export default __webpack_public_path__ + "static/media/vision.3cd2a7c13b22eaf8bbe1f4729f08c43d.svg";
export { ForwardRef as ReactComponent };